import { UPDATE_MEMBER_COMMON_STATUS } from "@/store/mutation.type";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class MemberStatusMixin extends Vue {
  // 访员的公共状态缓存
  get member_status_store() {
    return this.$store.state["member-status"].status_store;
  }
  set member_status_store(payload: { key: string; value: any }) {
    this.$store.commit(UPDATE_MEMBER_COMMON_STATUS, payload);
  }

  public setCommonStatus(key: string, value: any) {
    this.member_status_store = { key, value };
  }
}
